import React, { useState, useEffect } from "react";
import { baseUrl } from "../../api/common";
import axios from "axios";
import { convertDBDate } from './common';
// import { showToast, ToastMessage } from "../Shared/ToastMessage";
import Loader from "../common/Loader";
import UpdateMembershipApplicationComponent from "./UpdateMembershipApplicationComponent";

const ViewUserMembershipApplicationComponent = ({
  page,
  memberId,
  handlePrevTab,
  handlePayment
}) => {
  const [memberDetails, setMemberDetails] = useState({});
  const [clinicAddress, setClinicAddress] = useState([]);
  const [procedures, setProcedures] = useState([]);
  const [addPopupStatus, setaddPopupStatus] = useState(false);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const handleUpdatePopup = (status) => {
    setaddPopupStatus(status);
  };
  const fetchMemberDetailsData = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/member_detail`,
        { id: memberId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      );
      if (response.data.status) {
        setMemberDetails(response.data.data[0]);
        setClinicAddress(response.data.clinic);
        setProcedures(response.data.work_exp);
        console.log(response.data, "fetchMemberDetailsData");
      } else {
        console.error("Error: Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    }
  };

  const workExpInYears = (from, to) => {
    const year1 = new Date(from).getFullYear();
    const year2 = new Date(to).getFullYear();
    return year2 - year1;
  };

  useEffect(() => {
    fetchMemberDetailsData();
  }, [memberId]);

    const handleSubmit = async () => {
    setIsLoadingSubmit(true);
    try {
      await handlePayment(memberDetails.application_id);
    } catch (error) {
      console.error("Error processing payment:", error);
      // showToast("Failed to process payment. Please try again.", "error");
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  return (
    <div className="view_total_page">
      {/* <ToastMessage /> */}
      {/* {viewPopupStatus && (
        <div
          className={`extraspace_search_div search_div${viewPopupStatus ? " open" : ""
            }`}
        > */}
      {page !== "review"  &&
        <div className="row user_application_div_clr user_tab">
          <div className="col-md-6">
            <div className="tracking_head">
              <h2>Application Preview</h2>
            </div>
          </div>
          {(memberDetails&&memberDetails.application_status!==10)&&
          <div className="col-md-6 text-end pb-4">
            <button
              onClick={() => handleUpdatePopup(true)}
              className="btn btn-outline-success btn-sm ml-2 "
            >
              Update
            </button>
          </div>}
         {(memberDetails&&memberDetails.application_status===10)&&
          <div className="col-md-6 text-end pb-4">
            <button
              onClick={handleSubmit}
              className="btn btn-outline-success btn-sm ml-2"
              disabled={isLoadingSubmit}
            >
            {isLoadingSubmit ? (
              <>
                  <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                  ></span>
                  <span className="ms-2">Processing...</span>
              </>
              ) : ("Re-Payment")}              
            </button>
          </div>}
        </div>}
      <div className="card member_master_sidebar_scrool">

        {memberDetails ? (
          <div className="table-responsive">
            <div className="body  application_body_side">
              <fieldset>
                <div className="row clearfix">
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-md-3">
                        <div>
                          {memberDetails.profile && (
                            <img
                              src={`${memberDetails.profile}`}
                              width="80"
                              height="80"
                              className="img-thumbnail rounded-circle width_profile_image"
                              alt="person"
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-md-9">
                        <div className="application_id_date_flex pb-3">
                          <div>
                            <small className="text-muted">
                             <b>
                                {memberDetails.salutation ||memberDetails.first_name || memberDetails.middle_name || memberDetails.last_name
                                  ? `${memberDetails.salutation || ''} ${memberDetails.first_name || ''} ${memberDetails.middle_name || ''} ${memberDetails.last_name || ''}`
                                      .trim()
                                      .replace(/\s+/g, ' ')
                                  : 'N/A'}
                              </b>{" "}
                            </small>
                          </div>
                          {/* <div>
                                <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                                  <DropdownToggle caret>My Action</DropdownToggle>
                                  <DropdownMenu container="body">
                                    {applicationStatusData.map((action, index) => (
                                      <DropdownItem key={index} onClick={() => handleChangeApplicationStatus(action.id)}>
                                        {action.status_name}
                                      </DropdownItem>
                                    ))}
                                  </DropdownMenu>
                                </Dropdown>
                              </div> */}
                        </div>
                        <div className="application_id_date_flex">
                          <div>
                            <small className="text-muted">
                              <b>Application No:</b>
                            </small>
                            <p>{memberDetails.application_no?` ${memberDetails.application_no}`:'N/A'}</p>
                          </div>
                          {page !== "review" && memberDetails.membership_no &&
                            <div>
                              <small className="text-muted">
                                <b>Membership Number:</b>
                              </small>
                              <p>{` ${memberDetails.membership_no}`}</p>
                            </div>}
                          <div>
                            <small className="text-muted">
                              <b>Application Date:</b>{" "}
                            </small>
                            <p>
                              {convertDBDate(memberDetails.created_on)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 pt-3 pb-2">
                    <div className="row">
                      <div className="col-md-8">
                        <small className="text-muted">
                          <b>To</b>{" "}
                        </small>
                        <p>
                          The Honorary Secretary General,
                          <br />
                          Association of Minimal Access Surgeons of India
                          (AMASI)
                        </p>
                      </div>
                    </div>

                    <small className="text-muted">
                      <b>Dear Sir,</b>{" "}
                    </small>
                    <p>
                      I wish to become a {memberDetails.application_name} of the
                      Association and if selected, I agree to abide by the
                      rules and regulations of the Association. I hereby
                      declare that the information provided by me is correct
                      and if found incorrect my membership may be forfeited.
                    </p>
                  </div>
                  <div className="col-md-12">
                    <div className="card">
                      <div className="header">
                        <h2>Info</h2>
                      </div>
                      <div className="body">
                        <div className="row">
                          {memberDetails.salutation &&
                          <div className="col-6">
                            <small className="text-muted">
                              <b>Name Salutation:</b>{" "}
                            </small>
                            <p>{memberDetails.salutation || "N/A"}</p>
                          </div>}
                          <div className="col-6">
                            <small className="text-muted">
                              <b>First Name:</b>{" "}
                            </small>
                            <p>{memberDetails.first_name || "N/A"}</p>
                          </div>
                          <div className="col-6">
                            <small className="text-muted">
                              <b>Middle Name: </b>
                            </small>
                            <p>{memberDetails.middle_name || "N/A"}</p>
                          </div>
                          <div className="col-6">
                            <small className="text-muted">
                              <b>Last Name: </b>
                            </small>
                            <p>{memberDetails.last_name || "N/A"}</p>
                          </div>
                          <div className="col-6">
                            <small className="text-muted">
                              <b>Father's Name: </b>
                            </small>
                            <p>{memberDetails.father_name || "N/A"}</p>
                          </div>
                          <div className="col-6">
                            <small className="text-muted">
                              <b>Date of Birth: </b>
                            </small>
                            <p>
                              {memberDetails.dob?convertDBDate(memberDetails.dob) : "N/A"}
                            </p>
                          </div>
                          {page !== "review" &&
                            <div className="col-6">
                              <small className="text-muted">
                                <b>Date of Joining: </b>
                              </small>
                              <p>
                                {memberDetails.joining_date?convertDBDate(memberDetails.joining_date) : "N/A"}    
                              </p>
                            </div>
                          }
                          <div className="col-6">
                            <small className="text-muted">
                              <b>Email address: </b>
                            </small>
                            <p>{memberDetails.email || "N/A"}</p>
                          </div>
                          <div className="col-6">
                            <small className="text-muted">
                              <b>Mobile: </b>
                            </small>
                            <p>{memberDetails.mobile || "N/A"}</p>
                          </div>
                          <div className="col-6">
                            <small className="text-muted">
                              <b>Nationality: </b>
                            </small>
                            <p>{memberDetails.nationality || "N/A"}</p>
                          </div>
                          <div className="col-6">
                            <small className="text-muted">
                              <b>Gender: </b>
                            </small>
                            <p>{memberDetails.gender || "N/A"}</p>
                          </div>
                          <div className="col-6">
                            <small className="text-muted">
                              <b>AGE: </b>
                            </small>
                            <p>{memberDetails.age || "N/A"}</p>
                          </div>
                          <div className="col-6">
                            <small className="text-muted">
                              <b>City / District: </b>
                            </small>
                            <p>{memberDetails.city || "N/A"}</p>
                          </div>
                          <div className="col-6">
                            <small className="text-muted">
                              <b>State: </b>
                            </small>
                            <p>{memberDetails.state_name || "N/A"}</p>
                          </div>
                          <div className="col-6">
                            <small className="text-muted">
                              <b>Zone: </b>
                            </small>
                            <p>{memberDetails.zone || "N/A"}</p>
                          </div>
                          <div className="col-6">
                            <small className="text-muted">
                              <b>Country: </b>
                            </small>
                            <p>{memberDetails.country_name || "N/A"}</p>
                          </div>
                          <div className="col-12">
                            <small className="text-muted">
                              <b>Permanent Address: </b>
                            </small>
                            <p>
                              {`${memberDetails.street_line1 || ""}, ${memberDetails.street_line2 || ""
                                }, ${memberDetails.city || ""}, ${memberDetails.state_name || ""
                                }, ${memberDetails.country_name || ""}, ${memberDetails.pin || ""
                                }`}
                            </p>
                            {/* <p>
                                  {`${memberDetails.street_line1}, ${memberDetails.street_line2}, ${memberDetails.city}, ${memberDetails.pin}`}{" "}
                                </p> */}
                          </div>
                          <div className="col-12">
                            <small className="text-muted">
                              <b>Mailing Address:</b>{" "}
                            </small>
                            <p>
                              {`${memberDetails.street_line1 || ""}, ${memberDetails.street_line2 || ""
                                }, ${memberDetails.city || ""}, ${memberDetails.state_name || ""
                                }, ${memberDetails.country_name || ""}, ${memberDetails.pin || ""
                                }`}
                            </p>
                            {/* <p>
                                  {`${memberDetails.street_line1}, ${memberDetails.street_line2}, ${memberDetails.city}, ${memberDetails.pin}`}
                                </p> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="table_profile_list_border ">
                      <div className="card">
                        <div className="header">
                          <h2>Qualifications </h2>
                        </div>
                        <div className="body overflow_auto">
                          <table
                            id="row-table"
                            className="table table-striped"
                          >
                            <thead>
                              <tr>
                                <th>Qualification Name</th>
                                <th>Degree</th>
                                <th>College</th>
                                <th>University</th>
                                <th>Year of Passing</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>MBBS</td>
                                <td>N/A</td>
                                <td>
                                  {memberDetails.edu_undergrad_college ||
                                    "N/A"}
                                </td>
                                <td>
                                  {memberDetails.edu_undergrad_university ||
                                    "N/A"}
                                </td>
                                <td>
                                  {memberDetails.edu_undergrad_year ||
                                    "N/A"}
                                </td>
                              </tr>
                              <tr>
                                <td>Post Graduation</td>
                                <td>
                                  {memberDetails.edu_postgrad_degree ||
                                    "N/A"}
                                </td>
                                <td>
                                  {memberDetails.edu_postgrad_college ||
                                    "N/A"}
                                </td>
                                <td>
                                  {memberDetails.edu_postgrad_university ||
                                    "N/A"}
                                </td>
                                <td>
                                  {memberDetails.edu_postgrad_year || "N/A"}
                                </td>
                              </tr>
                              <tr>
                                <td>Super Speciality</td>
                                <td>
                                  {memberDetails.edu_superspecialty_degree ||
                                    "N/A"}
                                </td>
                                <td>
                                  {memberDetails.edu_superspecialty_college ||
                                    "N/A"}
                                </td>
                                <td>
                                  {memberDetails.edu_superspecialty_university ||
                                    "N/A"}
                                </td>
                                <td>
                                  {memberDetails.edu_superspecialty_year ||
                                    "N/A"}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="body">
                        <div className="row">
                          <div className="col-6">
                            <small className="text-muted">
                              <b>NMC/State Medical Council number: </b>
                            </small>
                            <p>
                              {memberDetails.mci_council_number || "N/A"}{" "}
                            </p>
                          </div>
                          <div className="col-6">
                            <small className="text-muted">
                              <b>NMC State: </b>
                            </small>
                            <p>
                              {memberDetails.mci_council_state_name || "N/A"}
                            </p>
                          </div>
                          <div className="col-6">
                            <small className="text-muted">
                              <b>IMR Number: </b>
                            </small>
                            <p>{memberDetails.imr_reg_no || "N/A"}</p>
                          </div>
                          <div className="col-6">
                            <small className="text-muted">
                              <b>Any other international Organisations: </b>
                            </small>
                            <p>
                              {memberDetails.other_inter_organisation ||
                                "N/A"}
                            </p>
                          </div>
                          <div className="col-6">
                            <small className="text-muted">
                              <b>Please Mention (If others): </b>
                            </small>
                            <p>{memberDetails.other_inter_organisation_value || "N/A"}</p>
                          </div>
                          <div className="col-6">
                            <small className="text-muted">
                              <b>ASI Registration Number: </b>
                            </small>
                            <p>
                              {memberDetails.asi_membership_no || "N/A"}
                            </p>
                          </div>
                          <div className="col-6">
                            <small className="text-muted">
                              <b>ASI State: </b>
                            </small>
                            <p>{memberDetails.asi_state_name || "N/A"}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="table_profile_list_border ">
                      <div className="card">
                        <div className="header">
                          <h2>Work Experience </h2>
                        </div>
                        <div className="body overflow_auto">
                          <table
                            id="row-table"
                            className="table table-striped"
                          >
                            <thead>
                              <tr>
                                <th>Position</th>
                                <th>Experience (From)</th>
                                <th>Experience (To)</th>
                                <th>Total Experience (Years)</th>
                              </tr>
                            </thead>
                            <tbody>
                              {procedures && procedures.length > 0 ? (
                                procedures.map((procedure, index) => (
                                  <tr key={index}>
                                    <td>
                                      {procedure.work_procedure || "NA"}
                                    </td>
                                    <td>
                                      {procedure.no_of_procedures1 || "NA"}
                                    </td>
                                    <td>
                                      {procedure.no_of_procedures2 || "NA"}
                                    </td>
                                    <td>
                                      {workExpInYears(procedure.no_of_procedures1, procedure.no_of_procedures2) || "NA"}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="4" className="text-center">
                                    No procedure data available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>

                      </div>
                    </div>
                    <div className="table_profile_list_border ">
                      <div className="card">
                        <div className="header">
                          <h2>Clinic / Hospital Address</h2>
                        </div>
                        <div className="body overflow_auto">
                          <table
                            id="row-table"
                            className="table table-striped"
                          >
                            <thead>
                              <tr>
                                <th>Clinic Name</th>
                                <th>Address</th>
                                <th>Country</th>
                                <th>State</th>
                                <th>City</th>
                                <th>Pin</th>
                                <th>Landline</th>
                              </tr>
                            </thead>
                            <tbody>
                              {clinicAddress && clinicAddress.length > 0 ? (
                                clinicAddress.map((clinic, index) => (
                                  <tr key={index}>
                                    <td>{clinic.clinic_name || "NA"}</td>
                                        <td>
                                          {clinic.clinic_address_one || clinic.clinic_address_two
                                            ? `${clinic.clinic_address_one || ''} ${clinic.clinic_address_two || ''}`.trim().replace(/\s+/g, ' ')
                                            : 'N/A'}
                                        </td>
                                    <td>
                                      {clinic.clinic_country_name || "NA"}
                                    </td>
                                    <td>
                                      {clinic.clinic_state_name || "NA"}
                                    </td>
                                    <td>{clinic.clinic_city || "NA"}</td>
                                    <td>
                                      {clinic.clinic_pin_code || "NA"}
                                    </td>
                                    <td>
                                      {clinic.clinic_stdcode
                                        ? `(${clinic.clinic_stdcode}) ${clinic.clinic_landline}`
                                        : clinic.clinic_landline || "NA"}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="7" className="text-center">
                                    No clinic data available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="table_profile_list_border ">
                      <div className="card">
                        <div className="header">
                          <h2>Documents</h2>
                        </div>
                        <div className="body overflow_auto">
                          <table
                            id="row-table"
                            className="table table-striped"
                          >
                            <thead>
                              <tr>
                                <th>Document Name</th>
                                <th className="text-center">File</th>
                              </tr>
                            </thead>
                            <tbody>
                              {([1, 2, 6].includes(
                                memberDetails.application_id
                              ) && `${memberDetails.country}`==="101") && (
                                  <tr>
                                    <td>NMC Certificate</td>
                                    <td className="text-wecenter">
                                      {/* <button
                                          className="btn btn-outline-info btn-block width-fit"
                                          type="button"
                                        >
                                          View Document
                                        </button> */}
                                      <a
                                        href={`${memberDetails.mci_certificate}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-outline-info btn-block width-fit"
                                      >
                                        View Document
                                      </a>
                                    </td>
                                  </tr>
                                )}
                              {([1, 2, 3, 6].includes(
                                memberDetails.application_id
                              )|| `${memberDetails.country}`!=="101") && (
                                  <tr>
                                    <td>
                                      Post Graduation Degree Certificate
                                    </td>
                                    <td className="text-wecenter">
                                      <a
                                        href={`${memberDetails.pg_degree_certificate}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-outline-info btn-block width-fit"
                                      >
                                        View Document
                                      </a>
                                    </td>
                                  </tr>
                                )}
                              {([1, 5, 6].includes(
                                memberDetails.application_id
                              )&& `${memberDetails.country}`==="101") &&  (
                                  <tr>
                                    <td>ASI Membership Certificate</td>
                                    <td className="text-wecenter">
                                      {/* <button
                                          className="btn btn-outline-info btn-block width-fit"
                                          type="button"
                                        >
                                          View Document
                                        </button> */}
                                      <a
                                        href={`${memberDetails.asi_member_certificate}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-outline-info btn-block width-fit"
                                      >
                                        View Document
                                      </a>
                                    </td>
                                  </tr>
                                )}
                              {([3].includes(
                                memberDetails.application_id
                              )|| `${memberDetails.country}`!=="101") && (
                                  <tr>
                                    <td>
                                      Active License for Practicing Surgeons
                                    </td>
                                    <td className="text-wecenter">
                                      <a
                                        href={`${memberDetails.active_license}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-outline-info btn-block width-fit"
                                      >
                                        View Document
                                      </a>
                                      {/* <button
                                          className="btn btn-outline-info btn-block width-fit"
                                          type="button"
                                        >
                                          View Document
                                        </button> */}
                                    </td>
                                  </tr>
                                )}
                              {([4].includes(
                                memberDetails.application_id
                              )&& `${memberDetails.country}`==="101") &&  (
                                  <tr>
                                    <td>Letter from HOD</td>
                                    <td className="text-wecenter">
                                      <a
                                        href={`${memberDetails.letter_hod}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-outline-info btn-block width-fit"
                                      >
                                        View Document
                                      </a>
                                      {/* <button
                                          className="btn btn-outline-info btn-block width-fit"
                                          type="button"
                                        >
                                          View Document
                                        </button> */}
                                    </td>
                                  </tr>
                                )}
                              {([4].includes(
                                memberDetails.application_id
                              ) && `${memberDetails.country}`==="101") && (
                                  <tr>
                                    <td>MBBS Degree certificate</td>
                                    <td className="text-wecenter">

                                      <a
                                        href={`${memberDetails.mbbs_degree_certificate}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-outline-info btn-block width-fit"
                                      >
                                        View Document
                                      </a>

                                      {/* <button
                                          className="btn btn-outline-info btn-block width-fit"
                                          type="button"
                                        >
                                          View Document
                                        </button> */}
                                    </td>
                                  </tr>
                                )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  {page === "review" &&
                    <div className="col-md-12">
                      <div className="last_form_submit_flex">
                        <div>
                          <button
                            onClick={handlePrevTab}
                            className="btn btn-outline-info btn-block saveand_proced_button"
                            type="button"
                          >
                            Back
                          </button>
                        </div>
                        <div>
                        <button
                          onClick={handleSubmit}
                          className="btn btn-outline-success btn-block saveand_proceed_button"
                          type="button"
                          disabled={isLoadingSubmit}
                        >
                        {isLoadingSubmit ? (
                          <>
                              <span
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                              ></span>
                              <span className="ms-2">Processing...</span>
                          </>
                          ) : ("Submit")}
                        </button>
                          {/* <button
                            // onClick={handlePrevTab}
                            className="btn btn-outline-success btn-block saveand_proced_button"
                            type="button"
                            onClick={handlePayment}
                          >
                            Submit
                          </button> */}
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </fieldset>
            </div>
          </div>
        ) : <Loader />}
      </div>
      {/* </div>
      )} */}
      <UpdateMembershipApplicationComponent
        memberId={memberId}
        eventType={"Update"}
        fetchPreviewMemberDetailsData={fetchMemberDetailsData}
        memberApplicationId={memberDetails.application_id}
        addPopupStatus={addPopupStatus}
        handleUpdatePopup={handleUpdatePopup}
      />
    </div>
  );
};
export default ViewUserMembershipApplicationComponent;
